import googlePlay from "/src/assets/google-play.svg";
import appStore from "/src/assets/app-store.svg";
import footerLogo from "/src/assets/images/footer/footer-logo.svg";
import footerSuper from "/src/assets/images/footer/SuperIntendencia.svg";

import fb from "/src/assets/images/footer/fb.svg"
import ig from "/src/assets/images/footer/ig.svg"
import tk from "/src/assets/images/footer/tk.svg"
import tw from "/src/assets/images/footer/tw.svg"
import yt from "/src/assets/images/footer/yt.svg"

import phone from "/src/assets/images/footer/call.png"
import mail from "/src/assets/images/footer/messages-2.png"
import chat from "/src/assets/images/footer/sms.png"

export const footerData = {
    logo: footerLogo,
    downloadText: "Descarga la aplicación",
    logoSuperintendencia: footerSuper,

    stores: [
        {
            type: "google-play",
            image: googlePlay,
            alt: "Disponible en Google Play",
            link: "https://play.google.com/store/apps/details?id=com.popular.app.android&pli=1",
            target: "_blank",
            rel: "noopener noreferrer"
        },
        {
            type: "app-store",
            image: appStore,
            alt: "Disponible en App Store",
            link: "https://apps.apple.com/us/app/banco-popular-dominicano/id583475424",
            target: "_blank",
            rel: "noopener noreferrer"
        }
    ],

    legales: {
        title: "Legales",
        links: [
            { label: "Derechos y deberes", link: "https://popularenlinea.com/proteccionalusuario#deberesDerechos" },
            { label: "Políticas de privacidad", link: "https://popularenlinea.com/Personas/Paginas/nosotros/politicas-de-seguridad.aspx" },
            { label: "Términos y condiciones", link: "https://popularenlinea.com/Personas/Paginas/nosotros/aviso-legal.aspx" },
            { label: "Políticas de Cookies", link: "https://popularenlinea.com/Personas/Paginas/nosotros/politica-cookies.aspx" }
        ]
    },

    contacto: {
        title: "Contacto",
        items: [
            {
                type: "email",
                label: "toke@bpd.com.do",
                link: "mailto:toke@bpd.com.doo",
                icon: mail
            },
            // {
            //     type: "phone",
            //     label: "(809) 544-5555",
            //     link: "tel:+18095445555",
            //     icon: phone
            // },
            {
                type: "chat",
                label: "Chat toke",
                link: "https://chat.popular.com.do/webchat/",
                icon: chat
            }
        ]
    },

    disclaimer:
        "© 2025 toke. Todos los derechos reservados. </br>Torre Empresarial 27 de febrero, piso 2. </br>Av. 27 de febrero #256, esq. C/ Federico Geraldino, Piantini, Santo Domingo, Distrito Nacional, Rep. Dom.",

    socialMedia: {
        title: "Síguenos",
        items: [
            {
                type: "x",
                label: "X",
                icon: tw,
                link: "https://x.com/toke",
                target: "_blank",
                rel: "noopener noreferrer"
            },
            {
                type: "facebook",
                label: "Facebook",
                icon: fb,
                link: "https://www.facebook.com/toke",
                target: "_blank",
                rel: "noopener noreferrer"
            },
            {
                type: "instagram",
                label: "Instagram",
                icon: ig,
                link: "https://www.instagram.com/toke",
                target: "_blank",
                rel: "noopener noreferrer"
            },
            {
                type: "youtube",
                label: "YouTube",
                icon: yt,
                link: "https://www.youtube.com/@toke",
                target: "_blank",
                rel: "noopener noreferrer"
            },
            {
                type: "tiktok",
                label: "TikTok",
                icon: tk,
                link: "https://www.tiktok.com/@toke",
                target: "_blank",
                rel: "noopener noreferrer"
            }
        ]
    }
};

